import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 1,
  class: "text-left w-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { class: "w-3/4" }),
  /*#__PURE__*/_createElementVNode("col", { class: "w-1/4" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "SOA data"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "py-1.5 font-medium"
    }, "Revalidate in")
  ])
], -1)
const _hoisted_5 = { class: "w-full ml-2 border-separate border-spacing-y-1.5" }
const _hoisted_6 = { class: "group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "font-medium"
}, "Start of authority", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "font-medium"
}, "Email", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "font-medium"
}, "Serial", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "font-medium"
}, "Refresh", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "font-medium"
}, "Retry", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "font-medium"
}, "Expire", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "row",
  class: "font-medium"
}, "Negative cache TTL", -1)
const _hoisted_15 = { class: "align-top" }
const _hoisted_16 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { QueryResult, RecordInfo, SOA } from '@/model/Api';

type SoaRecordWithInfo = {
  record: SOA;
} & RecordInfo

// Input:         'aa\.bb\.cc.domain.co.uk
// Match group 1: 'aa\.bb\.cc'
// Match group 3:            'domain.co.uk'

export default /*#__PURE__*/_defineComponent({
  __name: 'SoaRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const adminHostRegex = /^((.*\\\.)?[^.]*)\.(.*)/;

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => props.records.response.answer.filter((item): item is SoaRecordWithInfo => item.record.recordType === 'SOA'));

const adminUserAndHost = computed(() => {
  if (processedRecords.value.length > 0) {
    const match = processedRecords.value[0].record.admin.match(adminHostRegex);
    if (match) {
      return {
        user: match[1].replaceAll('\\.', '.'),
        host: match[3].slice(0, -1), // Remove the trailing dot
      };
    }
  }
  return {
    user: '',
    host: '',
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showRawOutput))
      ? (_openBlock(), _createBlock(RawRecords, {
          key: 0,
          records: __props.records
        }, null, 8, ["records"]))
      : (_unref(processedRecords).length !== 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedRecords), (record, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("table", _hoisted_5, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_6, [
                          _hoisted_7,
                          _createElementVNode("td", null, [
                            _createVNode(DnsRecordsLink, {
                              domain: record.record.host,
                              class: "text-blue-600 hover:text-blue-800 hover:underline"
                            }, null, 8, ["domain"]),
                            _createVNode(Copy, {
                              content: record.record.host,
                              class: "[visibility:hidden] group-hover:visible"
                            }, null, 8, ["content"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_8,
                          _createElementVNode("td", null, [
                            _createTextVNode(_toDisplayString(_unref(adminUserAndHost).user) + "@", 1),
                            (__props.domain !== _unref(adminUserAndHost).host)
                              ? (_openBlock(), _createBlock(DnsRecordsLink, {
                                  key: 0,
                                  domain: _unref(adminUserAndHost).host,
                                  class: "text-blue-600 hover:text-blue-800 hover:underline"
                                }, null, 8, ["domain"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(adminUserAndHost).host), 1))
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_10,
                          _createElementVNode("td", null, _toDisplayString(record.record.serial), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_11,
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.refresh
                            }, null, 8, ["seconds"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_12,
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.retry
                            }, null, 8, ["seconds"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_13,
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.expire
                            }, null, 8, ["seconds"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_14,
                          _createElementVNode("td", null, [
                            _createVNode(Duration, {
                              seconds: record.record.minimum
                            }, null, 8, ["seconds"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, [
                    _createVNode(Duration, {
                      seconds: record.record.ttl
                    }, null, 8, ["seconds"])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, "No SOA records found."))
  ]))
}
}

})